<template>
    <th @click="$parent.sortCol(col_key)"
        :col_key="col_key"
        :class="[classes] + 'shrink-cell'"
        :title="title">
        {{ text }}
        <template v-if="sorting_key === col_key">
            <i v-if="sorting_direction === 'desc'" class="fa fa-sort-amount-desc"></i>
            <i v-else class="fa fa-sort-amount-asc"></i>
        </template>
    </th>
</template>

<script>
export default {
    props: {
        'title': {
            'type': String,
            'required': false,
        },
        'col_key': {
            'type': String,
            'required': true,
        },
        'classes': {
            'type': Array,
            'required': false,
            'default': function(){
                return [];
            },
        },
        'text': {
            'type': String,
            'required': true,
        },
        'sorting_key': {
            'type': String,
            'required': false,
            'default': 'id'
        },
        'sorting_direction': {
            'type': String,
            'required': false,
            'default': 'asc',
        },
    },
}
</script>
